import React, { createContext, useContext, useEffect, useState } from 'react'

import { useLocale } from './localeContext'

type BannerRecord = { text: string; enabled: boolean; url?: string }

interface BannerContextProps {
  bannerContent: BannerRecord | null
}

const BannerContext = createContext<BannerContextProps | undefined>(undefined)

interface BannerProviderProps {
  children: React.ReactNode
}

export const BannerProvider: React.FC<BannerProviderProps> = ({ children }) => {
  const { currentLocale } = useLocale()
  const [bannerContent, setBannerContent] = useState<BannerRecord | null>(null)

  useEffect(() => {
    if (!currentLocale) return

    setBannerContent(null)
    let cancelled = false

    fetch(`/api/banner?locale=${currentLocale}`)
      .then((res) => (res.ok ? res.json() : null))
      .then((banner) => {
        if (!cancelled) {
          setBannerContent(banner?.enabled ? banner : null)
        }
      })
      .catch(() => {
        if (!cancelled) {
          setBannerContent(null)
        }
      })

    return () => {
      cancelled = true
    }
  }, [currentLocale])

  return <BannerContext.Provider value={{ bannerContent }}>{children}</BannerContext.Provider>
}

export const useBanner = () => {
  const context = useContext(BannerContext)
  if (context === undefined) {
    throw new Error('useBanner must be used within a BannerProvider')
  }
  return context
}
